export default {
  path: '/v5/matches/:id',
  name: 'V5_match',
  component: () => import('./V5MatchPage.vue'),
};
